module.exports = __webpack_public_path__ + "img/social_post_mob.adc76536.jpg";